import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Table, Spin, Button, Modal, Tooltip } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons"; // Icons from Ant Design
import GiftCreationForm from "../../Forms/GiftCreationForm/GiftCreationForm"
const GiftTable = ({
  history,
  loading,
  data,
  callReFetch,
  dispatch,
  handleDelete,
}) => {
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedGift, setSelectedGift] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  // Update isMobileView based on window gift
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleOpenEditModal = async (id) => {
    const giftToEdit = data.find((gift) => gift._id === id);
    if (giftToEdit) {
      setSelectedGift(giftToEdit);
      setIsEditModalVisible(true);
    }
  };

  const handleCloseEditModal = () => {
    setIsEditModalVisible(false);
    setSelectedGift(null);
  };

  const renderActionButton = (id) => (
    <>
      {isMobileView ? (
        // Use icons on mobile view
        <>
          <Tooltip title="Edit">
            <Button
              icon={<EditOutlined />}
              onClick={() => handleOpenEditModal(id)}
              gift="small"
              shape="circle"
              style={{ marginRight: 8 }}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(id)}
              gift="small"
              shape="circle"
              danger
            />
          </Tooltip>
        </>
      ) : (
        // Use buttons on desktop view
        <>
          <Button
            onClick={() => handleOpenEditModal(id)}
            style={{ marginRight: 8 }}
          >
            Edit
          </Button>
          <Button onClick={() => handleDelete(id)} danger>
            Delete
          </Button>
        </>
      )}
    </>
  );

  const handleTableOnChange = (pagination, filteredInfo, sorter) => {
    dispatch({ type: "sorter", payload: sorter });
    dispatch({ type: "filteredInfo", payload: filteredInfo });
    callReFetch();
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      sorter: true,
    },
    {
      title: "Action",
      render: (item) => renderActionButton(item._id),
      width: 400,
    },
  ];

  return (
    <>
      <div style={{width: "50vw"}}>
        <Spin spinning={loading}>
          {data && (
            <Table
              columns={columns}
              dataSource={data}
              onChange={(pagination, filteredInfo, sorter) =>
                handleTableOnChange(pagination, filteredInfo, sorter)
              }
            />
          )}
        </Spin>
        <Modal
          title="Edit Gift"
          open={isEditModalVisible}
          footer={null}
          onCancel={handleCloseEditModal}
        >
          <GiftCreationForm
            history={history}
            isEditMode
            callReFetch={callReFetch}
            data={selectedGift}
            onClose={handleCloseEditModal}
          />
        </Modal>
      </div>
    </>
  );
};

GiftTable.propTypes = {
};

export default GiftTable;
